function CancelButton({ onCancel, text = 'Cancel', disabled = false }) {
    return (
        <button
            type="button"
            disabled={disabled}
            className={`inline-flex items-center justify-center rounded-full px-[22px] py-3 text-[14.5px] font-semibold transition-[transform,background-color] duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E7E0D5] focus-visible:ring-offset-2 ${
                disabled
                    ? 'cursor-not-allowed bg-[#F4F0EA] text-[#9AA0A6]'
                    : 'bg-[#EFE9E0] text-[#1A1D23] hover:bg-[#E7E0D5] active:translate-y-[1px]'
            }`}
            onClick={onCancel}>
            {text}
        </button>
    )
}

export default CancelButton
